

import {
	filterCommonAttributes,
	type SearchAIAnalyticsContextDataInput,
} from './analytics-helpers';
import type { commonAttributesType } from './types';

// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAIAnswerDialogQueryIntent } from './on-ai-answer-dialog-query-intent';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAIAnswerDialogDroppedOff } from './on-ai-answer-dialog-dropped-off';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAIAnswerDialogHidden } from './on-ai-answer-dialog-hidden';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAIAnswerDialogViewed } from './on-ai-answer-dialog-viewed';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAIAnswerLoadingDialogShown } from './on-ai-answer-loading-dialog-shown';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onSmartAnswerRouteDetection } from './on-smart-answer-route-detection';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAIAnswerDialogUnmount } from './on-ai-answer-dialog-unmount';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAIAnswerResultShown } from './on-ai-answer-result-shown';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onNonGenerativeAIAnswerResultShown } from './on-non-generative-ai-answer-result-shown';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAIAnswerNotShown } from './on-ai-answer-not-shown';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { aiAnswerExpandClicked } from './ai-answer-expand-clicked';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { aiAnswerCollapseClicked } from './ai-answer-collapse-clicked';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { aiAnswerExpandShown } from './ai-answer-expand-shown';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAIAnswerSourceClick } from './on-ai-answer-source-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAIAnswerSourceContextMenuClick } from './on-ai-answer-source-context-menu-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAIAnswerSourceExpandToggleClick } from './on-ai-answer-source-expand-toggle-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAIAnswerReturnLinkClick } from './on-ai-answer-return-link-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onLikeButtonClick } from './on-like-button-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onDislikeButtonClick } from './on-dislike-button-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onDeselectLikeButtonClick } from './on-deselect-like-button-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onDeselectDislikeButtonClick } from './on-deselect-dislike-button-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onFeedbackSubmit } from './on-feedback-submit';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onReportButtonClick } from './on-report-button-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onFollowUpSuggestionClick } from './on-follow-up-suggestion-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onErrorStateSuggestedQueriesShown } from './on-error-state-suggested-queries-shown';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onErrorStateSuggestedQueryClick } from './on-error-state-suggested-query-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onOpenChatButtonClick } from './on-open-chat-button-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onSendChatInput } from './on-send-chat-input';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onExpandButtonClicked } from './on-expand-button-clicked';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onWhoPrimaryViewProfileClick } from './on-who-primary-view-profile-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onWhoPrimaryViewProfileContextMenuClick } from './on-who-primary-view-profile-context-menu-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onWhoPrimaryCoordinationPillClick } from './on-who-primary-coordination-pill-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onWhoPrimaryCoordinationPillContextMenuClick } from './on-who-primary-coordination-pill-context-menu-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onWhoAdditionalMatchProfileClick } from './on-who-additional-match-profile-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onWhoAdditionalMatchProfileContextMenuClick } from './on-who-additional-match-profile-context-menu-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onRecentWorkItemClick } from './on-recent-work-item-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onRecentWorkItemContextMenuClick } from './on-recent-work-item-context-menu-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onRecentWorkLinkClick } from './on-recent-work-link-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onRecentWorkLinkContextMenuClick } from './on-recent-work-link-context-menu-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onCuratedDefinitionEditButtonClicked } from './on-curated-definition-edit-button-clicked';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onCuratedDefinitionNextButtonClicked } from './on-curated-definition-next-button-clicked';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onCuratedDefinitionUpdateButtonClicked } from './on-curated-definition-update-button-clicked';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onCuratedDefinitionSeeEditHistoryButtonClicked } from './on-curated-definition-see-edit-history-button-clicked';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onCuratedDefinitionEditButtonShown } from './on-curated-definition-edit-button-shown';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAIAnswerCopyButtonClicked } from './on-ai-answer-copy-button-clicked';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onReadMoreButtonShown } from './on-read-more-button-shown';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onReadMoreButtonClicked } from './on-read-more-button-clicked';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onKnowledgeCardLoadingDialogShown } from './on-knowledge-card-loading-dialog-shown';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onJiraNlToJqlCardLoaded } from './on-jira-nl-to-jql-card-loaded';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onJiraIssueKeyClicked } from './on-jira-issue-key-clicked';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onJiraViewAllButtonClicked } from './on-jira-view-all-button-clicked';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAIAnswerDialogClick } from './on-ai-answer-dialog-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAIResultHoverStart } from './on-ai-result-hover-start';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAIResultHoverStop } from './on-ai-result-hover-stop';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAIAnswerTabClick } from './on-ai-answer-tab-click';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAIAnswerResultCompleteShown } from './on-ai-answer-result-complete-shown';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAIAnswerResultFirstByteShown } from './on-ai-answer-result-first-byte-shown';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onStreamingEarlyStopCardShown } from './on-streaming-early-stop-card-shown';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onStreamingEarlyStopCardDismissed } from './on-streaming-early-stop-card-dismissed';

export enum SearchAIAnalyticsContextLocation {
	AI_DEFINITION = 'ai-definition',
	SAIN_AGENT_CARD = 'sain-agent-card',
	SAIN_BOOKMARK = 'sain-bookmark',
	SAIN_JIRA_ISSUE_CARD = 'sain-jira-issue-card',
	SAIN_JIRA_NL_TO_JQL_CARD = 'sain-jira-nl-to-jql-card',
	SAIN_PERSON_CARD = 'sain-person-card',
	SAIN_Q_AND_A_CARD = 'sain-q-and-a-card',
	SAIN_TEAM_CARD = 'sain-team-card',
	SEARCH_RESULT_CONFLUENCE_CARD = 'search-result-confluence-card',
}

/**
 * Builds `data` for {@link SearchAIAnalyticsContext}: merges {@link filterCommonAttributes} with `location`.
 * Allowlist sanitization runs only inside {@link SearchAIAnalyticsContext}.
 */
export const getSearchAIAnalyticsContextData = ({
	location,
	commonAttributes,
}: {
	location: SearchAIAnalyticsContextLocation;
	commonAttributes: commonAttributesType;
}): SearchAIAnalyticsContextDataInput => {
	const filtered = filterCommonAttributes(commonAttributes);
	return {
		location,
		attributes: {
			...filtered,
			location,
		},
	};
};
